import { StudentLiveClassesPage } from './pages/LiveClassesPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RoleLayout } from '@/components/layout/RoleLayout';
import { AccountPage } from '@/features/auth/pages/AccountPage';
import { NotificationsCenter } from '@/features/auth/pages/NotificationsCenter';
import { nav } from './nav';
import { DashboardPage } from './pages/DashboardPage';
import { LearnPage } from './pages/LearnPage';
import { LessonDetailPage } from './pages/LessonDetailPage';
import { AssignmentDetailPage } from './pages/AssignmentDetailPage';
import { TestsPage } from './pages/TestsPage';
import { TestResultPage } from './pages/TestResultPage';
import { ResultsPage } from './pages/ResultsPage';
import { TimetablePage } from './pages/TimetablePage';
import { SubjectsPage } from './pages/SubjectsPage';
import { AttendancePage } from './pages/AttendancePage';
import { UniformPage } from './pages/UniformPage';
import { CalendarPage } from './pages/CalendarPage';

export function studentRoutes() {
  return (
    <Routes>
      <Route element={<RoleLayout title="Student" base="/student" nav={nav} />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="timetable" element={<TimetablePage />} />
        <Route path="subjects" element={<SubjectsPage />} />
        <Route path="learn" element={<LearnPage />} />
        <Route path="learn/lessons/:id" element={<LessonDetailPage />} />
        <Route path="learn/assignments/:id" element={<AssignmentDetailPage />} />
        <Route path="live" element={<StudentLiveClassesPage />} />
        <Route path="tests" element={<TestsPage />} />
        <Route path="tests/attempts/:id/result" element={<TestResultPage />} />
        <Route path="results" element={<ResultsPage />} />
        <Route path="attendance" element={<AttendancePage />} />
        <Route path="uniform" element={<UniformPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="notifications" element={<NotificationsCenter />} />
        <Route path="account" element={<AccountPage showPin={false} />} />
      </Route>
    </Routes>
  );
}
